var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 148 148",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-15.6597,-436.543)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.188,131.685C5.855,125.352 5.437,115.404 11.057,108.595L17.811,115.348L13.739,119.42C13.109,120.05 12.762,120.887 12.762,121.777C12.762,122.667 13.109,123.505 13.739,124.134L19.738,130.134C20.368,130.764 21.205,131.11 22.095,131.11C22.985,131.11 23.823,130.764 24.452,130.134L28.524,126.062L35.278,132.816C28.468,138.435 18.519,138.017 12.188,131.685ZM38.409,131.198L28.524,121.312L22.095,127.741L16.113,121.795L22.56,115.348L12.675,105.464C12.225,105.013 11.593,104.746 10.963,104.772C10.33,104.784 9.72,105.055 9.292,105.516C1.717,113.655 1.946,126.193 9.813,134.059C13.842,138.089 19.096,140.115 24.357,140.115C29.368,140.115 34.386,138.276 38.357,134.581C38.817,134.152 39.088,133.543 39.1,132.911C39.112,132.272 38.86,131.648 38.409,131.198Z",
    style: {
      fill: "rgb(5,64,151)",
      fillRule: "nonzero"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.65f9b0aaeb2433595637215d5c435b2c.svg";
export { ForwardRef as ReactComponent };